// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiPrescriber {
    static getAttributeTypeMap() {
        return PharmacyBiPrescriber.attributeTypeMap;
    }
}
PharmacyBiPrescriber.discriminator = undefined;
PharmacyBiPrescriber.additionalProperties = false;
PharmacyBiPrescriber.attributeTypeMap = [
    {
        "name": "address",
        "baseName": "address",
        "type": "PharmacyBiAddress"
    },
    {
        "name": "fax",
        "baseName": "fax",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "inNetwork",
        "baseName": "inNetwork",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "taxId",
        "baseName": "taxId",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiPrescriber.js.map